import t from "@/lang/lang";
import { Pest } from "@/services/backend/pestcontrol/types/pest";
import { Checkbox } from "@/shared/components/ui/checkbox";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { AssessmentField } from "@/services/backend/gfs/assessment/components/assessment-field";

export function PestSelection({
  pests,
  selected,
  derived,
  onChange,
}: {
  pests: Pest[];
  selected: string[];
  derived: Set<string>;
  onChange: (nextManualIDs: string[]) => void;
}) {
  return (
    <AssessmentField label={t("Zielorganismen")}>
      <div className="grid gap-2 sm:grid-cols-2">
        {pests.map((pest) => {
          const isDerived = derived.has(pest.id);
          const manualSelected = selected.includes(pest.id) && !isDerived;
          const checkbox = (
            <Checkbox
              checked={selected.includes(pest.id)}
              disabled={isDerived}
              onCheckedChange={(checked) =>
                onChange(
                  checked
                    ? [...selected.filter((id) => !derived.has(id)), pest.id]
                    : selected
                        .filter((id) => !derived.has(id))
                        .filter((id) => id !== pest.id),
                )
              }
            />
          );
          return (
            <label className="flex items-center gap-2 text-sm" key={pest.id}>
              {isDerived ? (
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span className="inline-flex">{checkbox}</span>
                  </TooltipTrigger>
                  <TooltipContent>
                    {t(
                      "Dieser Zielorganismus wird durch einen ausgewählten Monitor abgeleitet und kann deshalb nicht manuell entfernt werden.",
                    )}
                  </TooltipContent>
                </Tooltip>
              ) : (
                checkbox
              )}
              <span>{pest.name}</span>
              {!isDerived && manualSelected && (
                <span className="sr-only">{t("manuell ausgewählt")}</span>
              )}
            </label>
          );
        })}
      </div>
    </AssessmentField>
  );
}
